const CAPTCHA_ACTION = "growth_lab_registration";

const getCaptchaToken = async (executeV3) => {
  if (typeof executeV3 !== "function") {
    throw new Error("Google reCAPTCHA todavía no está disponible");
  }

  const token = await executeV3(CAPTCHA_ACTION);

  if (!token) {
    throw new Error("Google reCAPTCHA no generó un token");
  }

  return token;
};

export default getCaptchaToken;
